// 31f00f9403751c9634d984ded2c01f84f6e47943|name=QueryResultApiReadRowsParams|schemaHash=75c2b934d4b72c32820803197dcf03fac84b89b2|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

export function parseQueryResultApiReadRowsParamsFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'handleId', _data.handleId);
  setDefinedValue(result, 'offset', _data.offset);
  setDefinedValue(result, 'limit', _data.limit);

  return result;
}

export function parseQueryResultApiReadRowsParamsToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'handleId', _data.handleId);
  setDefinedValue(result, 'offset', _data.offset);
  setDefinedValue(result, 'limit', _data.limit);

  return result;
}
